import {useState} from "react";
import {useNotificationStore} from "@/Stores/NotificationStore";
import {useBasketStore} from "@/Stores/Site/Basket";
import {trackAddToBasket} from "@/features/basketActions/analytics/trackAddToBasket";
import {getProductByArticle} from "@/entities/product/api/productApi";
import {BASKET_UPDATED, basketEvents} from "@/shared/lib/events/basketEvents";
import {addOrUpdateBasket} from "@/entities/basket/api/basketApi";
import {useSelectSizeStore} from "@/Stores/Site/Product/SelectSizeStore";

export function useAddToBasket() {
    const [loading, setLoading] = useState(false);
    const [loadingId, setLoadingId] = useState(null);

    const setBasketProducts = useBasketStore(state => state.setBasketProducts);
    const openModalSelectSize = useSelectSizeStore(state => state.openModalSelectSize);
    const show = useNotificationStore(state => state.show);

    const addToBasket = async ({productId, productDataId, article, price}) => {
        if (loading) return;
        // if (loadingId === productId) return;

        try {
            setLoading(true);
            setLoadingId(productId);

            if (productDataId) {
                return handleAdd(productId, productDataId, price);
            }

            const response = await getProductByArticle({
                article,
                type: 'addBasket',
            });
            const {success = {}} = response.data;
            const {status = false, data = []} = success;

            if (!status) throw new Error('Не удалось получить данные');

            const {product = {}} = data;
            const {product_data = []} = product;
            if (product.product_data.length === 1 && product_data[0].razmer === '') {
                return handleAdd(product.id, product_data[0].id, price);
            }

            openModalSelectSize(product);
        } catch (e) {
            handleError();
        } finally {
            setLoading(false);
            setLoadingId(productId);
        }
    };

    const handleAdd = async (productId, productDataId, price) => {
        try {
            const response = await addOrUpdateBasket({
                productId,
                productDataId,
                count: 1,
                returnProduct: true,
                operationType: 'create',
            });

            const {success} = response.data;
            const {status = false, data = [], errors = []} = success;

            if (!status) throw new Error('Произошла ошибка при добавлении товара!');

            setBasketProducts(data.basketProducts);

            show({
                text: 'Товар добавлен!',
                basket: true,
            });

            trackAddToBasket({data, price, count: 1, productId});

            // Событие (данные в корзине изменены)
            basketEvents.dispatchEvent(new Event(BASKET_UPDATED));

        } catch (e) {
            handleError();
        }
    }

    const handleError = (message = 'Произошла ошибка при добавлении товара!') => {
        show({
            text: message,
            severity: 'error',
        });
    };

    return {addToBasket, loading, loadingId};
}
